import { render, staticRenderFns } from "./CentersForm.vue?vue&type=template&id=2c1f609c&scoped=true"
import script from "./CentersForm.vue?vue&type=script&lang=js"
export * from "./CentersForm.vue?vue&type=script&lang=js"
import style0 from "./CentersForm.vue?vue&type=style&index=0&id=2c1f609c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f609c",
  null
  
)

export default component.exports